import { render } from "./proposition-approved-badge.vue?vue&type=template&id=3e4fb914&scoped=true"
import script from "./proposition-approved-badge.vue?vue&type=script&lang=js"
export * from "./proposition-approved-badge.vue?vue&type=script&lang=js"

import "./proposition-approved-badge.vue?vue&type=style&index=0&id=3e4fb914&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4fb914"]])

export default __exports__